// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */

.jp-pluginmanager {
  display: grid;
  grid-template-rows: min-content min-content 1fr;
}

.jp-pluginmanager-Header,
.jp-pluginmanager-Disclaimer {
  padding: 8px;
}

.jp-pluginmanager-Disclaimer-checkbox {
  position: relative;
  top: 2px;
}

.jp-pluginmanager-AvailableList {
  overflow: auto;
}

.jp-pluginmanager-AvailableList > .jp-sortable-table > thead {
  position: sticky;
}

.jp-pluginmanager-PluginInUseMessage {
  max-width: 550px;
}

.jp-pluginmanager-Header > .jp-FilterBox {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@jupyterlab/pluginmanager/style/base.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb","sourcesContent":["/*\n * Copyright (c) Jupyter Development Team.\n * Distributed under the terms of the Modified BSD License.\n */\n\n.jp-pluginmanager {\n  display: grid;\n  grid-template-rows: min-content min-content 1fr;\n}\n\n.jp-pluginmanager-Header,\n.jp-pluginmanager-Disclaimer {\n  padding: 8px;\n}\n\n.jp-pluginmanager-Disclaimer-checkbox {\n  position: relative;\n  top: 2px;\n}\n\n.jp-pluginmanager-AvailableList {\n  overflow: auto;\n}\n\n.jp-pluginmanager-AvailableList > .jp-sortable-table > thead {\n  position: sticky;\n}\n\n.jp-pluginmanager-PluginInUseMessage {\n  max-width: 550px;\n}\n\n.jp-pluginmanager-Header > .jp-FilterBox {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
